import React, { useState } from "react"
import "../../Styles/index.scss"
//import "../../Styles/singlepost.scss"
import Post from "../post"
import { graphql, StaticQuery } from "gatsby"
import { Row, Col } from "react-bootstrap"
import Img from "gatsby-image"
import { Link } from "gatsby"
import Smallpost from "../smallpost"
function Postrender() {
  const [biggest, setbiggest] = useState(false)
  return (
    <div>
      <StaticQuery
        query={homeconcert}
        render={data => {
          return (
            <div className="concert-home-posts">
              <Row className="justify-content-md-center">
                <Col md={9}>
                  <div className="three-big">

                    <Row>
                      {data.allMarkdownRemark.edges
                        .slice(0,10)
                        .map(({ node }) => (
                          <Col sm={4} className="two-smaller-posts">
                            <Smallpost
                              key={node.id}
                              title={node.frontmatter.title}
                              date={node.frontmatter.date}
                              slug={node.fields.slug}
                              body={node.excerpt}
                              fluid={
                                node.frontmatter.image.childImageSharp.fluid
                              }
                            />
                            <br />
                          </Col>
                        ))}
                    </Row>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="other-scroll">
                    {data.allMarkdownRemark.edges
                      .slice(10, 14)
                      .map(({ node }) => (
                        <div>
                          <Smallpost
                            key={node.id}
                            title={node.frontmatter.title}
                            date={node.frontmatter.date}
                            slug={node.fields.slug}
                            body={node.excerpt}
                            fluid={node.frontmatter.image.childImageSharp.fluid}
                          />
                          <br />
                        </div>
                      ))}
                      <Link to="./concertpage">
                        <span className="badge">
                        more
                      </span>
                      </Link>
                      
                  </div>
                </Col>
              </Row>
            </div>
          )
        }}
      />
    </div>
  )
}

const Concerthome = () => {
  return (
    <div className="home-concert-blog">
      <div className="all-posts">{Postrender()}</div>
    </div>
  )
}
const homeconcert = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { cat: { eq: "concert" } } }) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            image {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            cat
          }
          excerpt(truncate: true)
          fields {
            slug
          }
        }
      }
    }
  }
`

export default Concerthome

//   filter: { frontmatter: { cat: { eq: "news" } } }
